export default {
  // 對話框標題
  dialogTitle: "共同交易對手",

  // 選項標題
  commonInflowAbsolute: "共同流入（絕對）",
  commonInflowRelative: "共同流入（相對）",
  commonOutflowAbsolute: "共同流出（絕對）",
  commonOutflowRelative: "共同流出（相對）",

  // 選項說明
  commonInflowAbsoluteInfo: "所選節點有絕對的共同流入交易對手",
  commonInflowRelativeInfo: "所選節點有部分的共同流入交易對手",
  commonOutflowAbsoluteInfo: "所選節點有絕對的共同流出交易對手",
  commonOutflowRelativeInfo: "所選節點有部分的共同流出交易對手",
};
